<template>
    <div class="downloadwrap" :class="{'zIndex':show}">
        <div class="downloadbox">
            <img class="logo" :src="info.logo" alt="">
            <div>
                <pre>{{info.content}}</pre>
            </div>
            <a @click="download(info.url)">下载</a>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        info: {
            type: Object,
            default: function () {
                // var reg = /^daojia:.+/.test(window.downloadUrl)
                // if (window.isAppFlag && !reg) {
                //     window.downloadUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(window.downloadUrl);
                // }
                return {
                    logo: 'https://images.daojia.com/jz/pic/97e3b19805fee9f57e4bed2b8dd76d64.png',
                    content: '天鹅到家\r\n专业便捷安心的上门服务平台',
                    url: window.downloadUrl
                }
            }
        }
    },
    methods: {
        download(url){
            if(this.isApp()){
                if (this.getOSType == 1) {
                    window.location.href = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(url)
                    // let url = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(window.downloadUrl)
                    // window.location.href = url
                }else {
                    window.location.href = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(url)
                    // let url =  'daojia://openUrl/jumpPage?url=' + encodeURIComponent(window.downloadUrl)
                    // window.location.href = url
                }
            }else{
                window.location.href = url
            }
        },
        isApp(){
            var ret = false;
            var userAgent = navigator.userAgent;
            var ua = userAgent.toLowerCase();
            var cookiestr = document.cookie;
            if (userAgent.indexOf('cdvsupport') >= 0 || cookiestr.indexOf('cdvsupport') >= 0 || ua.indexOf("daojia") != -1 || ua.indexOf("58app") != -1) {
                ret = true;
            }
            return ret;
        },
        getOSType() {
            if (/(Android)/i.test(navigator.userAgent)) {
                return 0;
            } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                return 1;
            } else {
                return 2;
            }
        }
    }
}
</script>
<style>
.downloadwrap {
    z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// Download.vue?3c6c7b50